/**
 * The user pool's password policy (`infra/lib/auth-stack.ts`), mirrored so the
 * signup form can show each rule turning green as it is satisfied rather than
 * surfacing a Cognito InvalidPasswordException after submit.
 */
export type PasswordRuleId = "length" | "lower" | "upper" | "digit" | "symbol";

interface PasswordRule {
  id: PasswordRuleId;
  label: string;
  test: (pw: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: "length", label: "At least 8 characters", test: (pw) => pw.length >= 8 },
  { id: "lower", label: "A lowercase letter", test: (pw) => /[a-z]/.test(pw) },
  { id: "upper", label: "An uppercase letter", test: (pw) => /[A-Z]/.test(pw) },
  { id: "digit", label: "A number", test: (pw) => /[0-9]/.test(pw) },
  { id: "symbol", label: "A symbol", test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export interface PasswordRuleState {
  id: PasswordRuleId;
  label: string;
  met: boolean;
}

export function checkPassword(pw: string): { rules: PasswordRuleState[]; valid: boolean } {
  const rules = PASSWORD_RULES.map((r) => ({ id: r.id, label: r.label, met: r.test(pw) }));
  return { rules, valid: rules.every((r) => r.met) };
}
